import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private readonly router = inject(Router);

  currentYear = new Date().getFullYear();

  links = [
    { label: 'Services', href: 'services' },
    { label: 'Projects', href: 'projects' },
    { label: 'About', href: 'about' },
    { label: 'Contact', href: 'contact' },
  ];

  goHome() {
    void this.router.navigateByUrl('/');
  }

  goToSection(fragment: string) {
    if (this.router.url.split('#')[0] === '/' || this.router.url === '') {
      const el = document.getElementById(fragment);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    void this.router.navigate(['/'], { fragment });
  }
}
